import { HttpHeaders } from "@angular/common/http";

const headers = new HttpHeaders();
headers.append("Accept", "*/*");
headers.append("Content-Type", "application/json; charset=utf-8");

const httpOptions = { headers, withCredentials: true };

export { httpOptions };
